import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/files', {
			params: searchParams
		})
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/files/' + id)
	},

	createTenantFile(tenantId, formData) {
		return axios.post(window.dtServerUrl + '/files/tenant/' + tenantId, formData).then((response) => {
			return response?.data
		})
	},

	createAccountFile(accountId, formData) {
		return axios.post(window.dtServerUrl + '/files/account/' + accountId, formData).then((response) => {
			return response?.data
		})
	},

	downloadById(id) {
		return axios
			.get(window.dtServerUrl + '/files/' + id + '/download', {
				responseType: 'blob'
			})
			.then((response) => {
				return response?.data
			})
	},

	generateTTS(input, provider, voice, speed) {
		return axios
			.post(
				window.dtServerUrl + '/files/tts/generate',
				{ input, voice, speed, provider },
				{
					responseType: 'blob'
				}
			)
			.then((response) => {
				return response?.data
			})
	},

	getTTSSpec() {
		return axios.get(window.dtServerUrl + '/files/tts/spec').then((response) => {
			return response?.data
		})
	},

	update(tenant) {
		return axios.put(window.dtServerUrl + '/files/' + tenant.id, tenant).then((response) => {
			return response?.data
		})
	}
}
